document.addEventListener('DOMContentLoaded', () => {
  // Handle both bundle buttons and regular product forms
  const bundleButtons = document.querySelectorAll('.bundle-add-button');
  const productForms = document.querySelectorAll('form[action*="/cart/add"]');
  
  // The Dawn cart custom element
  const cartItemsElement = document.querySelector('cart-items');
  if (!cartItemsElement) return;

  // Handle bundle buttons (existing functionality)
  bundleButtons.forEach((btn) => {
    btn.addEventListener('click', handleBundleAdd);
  });

  // Handle regular product forms
  productForms.forEach((form) => {
    form.addEventListener('submit', handleFormSubmit);
  });

  function handleBundleAdd(event) {
    const btn = event.target;
    const variantId = btn.dataset.variantId;
    const quantity = parseInt(btn.dataset.qty || '1', 10);

    if (!variantId || !quantity) {
      console.warn('Missing variant id or quantity on bundle-add-button');
      return;
    }

    addToCartWithSections(variantId, quantity);
  }

  function handleFormSubmit(event) {
    event.preventDefault();
    
    const form = event.target;
    const formData = new FormData(form);
    
    // Get variant ID from form
    const variantId = formData.get('id');
    const quantity = parseInt(formData.get('quantity') || '1', 10);

    if (!variantId) {
      console.warn('Missing variant id in product form');
      return;
    }

    // Show loading state
    const submitButton = form.querySelector('[type="submit"]');
    if (submitButton) {
      submitButton.classList.add('loading');
      const spinner = submitButton.querySelector('.loading__spinner');
      if (spinner) spinner.classList.remove('hidden');
    }

    addToCartWithSections(variantId, quantity, submitButton);
  }

  function addToCartWithSections(variantId, quantity, button = null) {
    // Build form data for /cart/add
    const formData = new FormData();
    formData.append('items[0][id]', variantId);
    formData.append('items[0][quantity]', quantity);

    // Ask Shopify to also return updated cart sections
    const sectionsToRender = cartItemsElement
      .getSectionsToRender()
      .map((section) => section.section);

    formData.append('sections', sectionsToRender);
    formData.append('sections_url', window.location.pathname);

    fetch(`${routes.cart_add_url}`, {
      method: 'POST',
      body: formData
    })
      .then((response) => response.text())
      .then((state) => {
        const parsedState = JSON.parse(state);
        // Reuse Dawn's built-in method to replace HTML
        cartItemsElement.renderContents(parsedState);
        
        // Remove loading state
        if (button) {
          button.classList.remove('loading');
          const spinner = button.querySelector('.loading__spinner');
          if (spinner) spinner.classList.add('hidden');
        }
      })
      .catch((error) => {
        console.error('Cart add error:', error);
        
        // Remove loading state
        if (button) {
          button.classList.remove('loading');
          const spinner = button.querySelector('.loading__spinner');
          if (spinner) spinner.classList.add('hidden');
        }
        
        // Fallback – just reload the page if something goes wrong
        window.location.reload();
      });
  }
});